import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

const store = {
  namespaced: true,
  state() {
    return {
      // backendcrm.cloudvillage.it:7751
      // "https://backendcrmtest.cloudvillage.it:7751", // per localhost testing
      base_address:
        window.location.href.split("/")[2] === "crm.cloudvillage.it"
          ? "https://backendcrm.cloudvillage.it:7751"
          : window.location.href.split("/")[2] === "crmtest.cloudvillage.it"
          ? "https://backendcrmtest.cloudvillage.it:7752"
          : "https://backend.cloudvillage.it:7751", // backend address
      website_address:
        window.location.href.split("/")[0] +
        "//" +
        window.location.href.split("/")[2], // backend address
      index_to_show: {
        nationality: true,
        conversion: true,
      },
      configs: [],
      urlToPrenotazioneCV: "",
      camping: {},
      tinyMCEsettings: {
        license_key: "gpl",
        height: 500,
        menubar: true,
        language: "it",
        branding: false,
        relative_urls: false,
        convert_urls: false,
        remove_script_host: false,
        force_br_newlines: true,
        allow_script_urls: true,
        valid_elements: "*[*]",
        file_picker_callback: function () {
          return false;
        },
        extended_valid_elements: "script[language|type|src]",
        plugins:
          "advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount",
        toolbar:
          "undo redo |  copy paste cut fontselect lineheight fontsizeselect forecolor formatselect | blockquote bold italic backcolor underline | alignleft aligncenter alignright alignjustify | lineheightselect bullist numlist outdent indent | removeformat | image | code | help",
        paste_data_images: false,
        help_accessibility: false,
        lineheight_formats:
          "2pt 4pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 36pt",
        encoding: "xml",
        placeholder: "Inizia a digitare...",
        highlight_on_focus: false,
        referrer_policy: "origin",
        contextmenu_never_use_native: true,
        promotion: false,
      },
    };
  },
  actions,
  getters,
  mutations,
};

export default store;
